import type { Configuration } from '@azure/msal-browser';
import { LogLevel } from '@azure/msal-browser';

// Configuration object for Microsoft Entra ID
export const msalConfig: Configuration = {
  auth: {
    // Replace with your Microsoft Entra ID application (client) ID
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || 'b5308d06-7dcf-4807-a2b3-ab8dc71ebadd', // Application (client) ID from Azure portal
    authority:  'https://login.microsoftonline.com/d3ff7c10-cde2-4a5d-b74d-3bdb1d848f16/v2.0', // Authority URL for Entra ID (v2.0 endpoint for login.microsoftonline.com issuer)
    redirectUri: '/', // Redirect URI after successful authentication
    postLogoutRedirectUri: '/', // Redirect URI after logout
  },
  cache: {
    cacheLocation: 'sessionStorage', // Store tokens in session storage
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
           // console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

// Scopes for API access
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

// Scopes for your custom API
export const apiRequest = {
  scopes: [import.meta.env.VITE_API_SCOPE || `api://${import.meta.env.VITE_AZURE_CLIENT_ID}/User.Read`], // Replace with your API scope
};

// Alternative: If you have a separate API app registration
export const customApiRequest = {
  scopes: ['api://your-api-client-id/access_as_user'], // Replace with your API's client ID
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
